import {createUseStyles} from 'react-jss'

const styles = theme => ({
	article: {
		maxWidth: '1000px',
		padding: '30px 0px',
		margin: '0 auto 0',
	},
	header: {
		display: 'flex',
		flexDirection: 'column',
		'@media screen and (min-width: 768px)': {
			flexDirection: 'row',
			marginBottom: '30px',
		}
	},
	title: {
		fontSize: '32px',
		lineHeight: '36px',
		'@media screen and (min-width: 768px)': {
			fontSize: '42px',
			lineHeight: '46px',
		},
		'& a': {
			color: theme.colors.gray[7],
			textDecoration: 'none',
			textAlign: 'left'
		},
	},
	date: {
		fontSize: '1em',
		color: '#919699'
	},
	author: {
		color: '#919699',
	},
	articleInfo: {
		textAlign: 'right',
		display: 'flex',
		flexShrink: '0',
		flexDirection: 'row',
		justifyContent: 'space-between',
		padding: '10px 0',
		'@media screen and (min-width: 768px)': {
			flexDirection: 'column',
			justifyContent: 'flex-start',
			padding: '0px',
			width: '180px',
		}
	},
	content: {},
	share: {
		cursor: 'pointer',
		fontSize: '16px',
		'& i': {
			marginLeft: '4px'
		}
	},
	picture: {
		borderRadius: '4px',
		textAlign: 'center',
		overflow: 'hidden',
		'@media (min-width: 768px)': {
			marginBottom: '30px'
		},
		'& img': {
			display: 'inline',
			width: '100%',
			margin: '0',
			borderRadius: '4px'
		}
	},
	markdown: {
		margin: '0 auto',
		maxWidth: '800px',
		'& > div': {
			fontWeight: theme.fontWeight.normal,
			fontSize: '14px',
			lineHeight: '20px',
			'@media (min-width: 768px)': {
				fontSize: '18px',
				lineHeight: '30px',
			},
			'& .paragraph': {
				padding: '5px 0 5px',
				'@media (min-width: 768px)': {
					padding: '10px 0 10px',
				},
				'& > strong': {
					display: 'block',
					marginTop: '10px',
					'@media (min-width: 768px)': {
						marginTop: '25px',
					},
				},
			},
			'& ul, & ol': {
				marginBottom: '10px',
				paddingLeft: '0px',
				paddingInlineStart: '40px'
			},
			'& ul li, & ol ul > li': {
				paddingBottom: '8px'
			}
		}
	},
	readMore: {
		float: 'right'
	},
	articleContainer: {
		width: '100%',
		backgroundColor: theme.colors.backgroundGray,
	},
	relatedInfo: {
		margin: '0 auto',
		width: '75%',
	}
});

const useStyles = createUseStyles(styles);

export default useStyles;
